import * as React from 'react';
import ReactDOM from 'react-dom';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import { withFormsy } from 'formsy-react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mate... Remove this comment to see the full error message
import { LinearProgress } from 'material-ui';
import moment from 'moment';
import type Q from 'q';

import S3Upload from 'bundles/internal-enterprise/utils/s3uploader';
import Button from 'bundles/internal-ui/components/buttons/Button';

import 'css!./__styles__/S3FileUploader';

@withFormsy
class S3FileUploader extends React.Component<
  {
    name: string;
    label: string;
    signingUrl: string;
    onFinish?: (result: $TSFixMe) => void;
    onError?: (message: string) => void;
    tooltip: string;
    fileInput?: string;
    validateFile: (input?: HTMLInputElement) => true | Q.Promise<boolean>;
    setUploadProgress?: (percent: number) => void;
    showError?: () => boolean;
    isValid?: () => boolean;
    getErrorMessage?: () => React.ReactNode;
    setValue?: (path: string) => void;
  },
  {
    progress: number | null;
  }
> {
  static defaultProps = {
    onError: (message: $TSFixMe) => {
      // eslint-disable-next-line
      console.log('Upload error: ' + message);
    },
    validateFile: (fileInput: $TSFixMe) => {
      return true;
    },
  };

  constructor(props: $TSFixMe) {
    super(props);
    this.state = { progress: null };
  }

  onFinish = (signResult: $TSFixMe) => {
    setTimeout(() => {
      this.setState({ progress: null });
    }, 3000);

    const { onFinish } = this.props;

    if (onFinish) {
      onFinish(signResult);
    }
  };

  onProgress = (percent: $TSFixMe, message: $TSFixMe) => {
    // eslint-disable-next-line
    console.log('Upload progress: ' + percent + '% ' + message);
    this.setState({ progress: percent });
    const { setUploadProgress } = this.props;
    if (setUploadProgress) {
      setUploadProgress(percent);
    }
  };

  onChange = (event: $TSFixMe) => {
    const { setValue } = this.props;
    setValue?.(event.currentTarget.value.replace('C:\\fakepath\\', '').replace(/\s+/g, '_'));
    this.setState({ progress: 0 });
    if (!this.validateFile()) {
      /* eslint-disable no-param-reassign */
      event.currentTarget.value = null; // reset value so user can keep updating/uploading same file
    }
  };

  onClick = () => {
    // eslint-disable-next-line
    (ReactDOM.findDOMNode(this.refs.fileInput) as any).click();
  };

  uploadFile = (isValid: $TSFixMe) => {
    if (isValid) {
      const { signingUrl, onError } = this.props;
      const uploader = new S3Upload({
        signingUrl,
        onProgress: this.onProgress,
        onFinishS3Put: this.onFinish,
        onError,
      });
      // eslint-disable-next-line
      uploader.handleFileSelect(ReactDOM.findDOMNode(this.refs.fileInput));
    } else {
      this.setState({ progress: null });
    }
  };

  validateFile = () => {
    const { validateFile } = this.props;
    // eslint-disable-next-line
    const validationValue = validateFile(ReactDOM.findDOMNode(this.refs.fileInput) as HTMLInputElement);
    const isPromise = typeof validationValue === 'object' && typeof validationValue.then === 'function'; // duck-type Promise signature

    if (isPromise) {
      (validationValue as Q.Promise<boolean>).then(this.uploadFile);
    } else {
      this.uploadFile(validationValue);
    }

    return validationValue;
  };

  filenameTooltip = () => {
    const { fileInput } = this.props;
    const fileString = fileInput?.match(/\d{2}_\d{2}_\d{4}_\d{2}_\d{2}_\d{2}_.*$/)?.[0];
    const date = moment.utc(fileString?.substring(0, 19), 'MM_DD_yyyy_HH_mm_ss');
    return fileString?.substring(20) + ' uploaded ' + date.fromNow();
  };

  renderProgressBar = () => {
    const { progress } = this.state;
    if (progress !== null) {
      return (
        <div className="uploadBar">
          <LinearProgress mode="determinate" value={progress} />
        </div>
      );
    }

    return null;
  };

  render() {
    let className = 'form-group';
    const { showError, isValid, getErrorMessage, name } = this.props;
    if (showError?.()) {
      className += ' has-error has-feedback';
    } else if (isValid?.()) {
      className += ' has-success';
    }

    const { fileInput } = this.props;
    const errorMessage = getErrorMessage?.();
    const inputTooltip = fileInput ? this.filenameTooltip() : 'Upload File';

    return (
      <div className={className}>
        {/* <TooltipLabel tooltip={this.props.tooltip} label={this.props.label} /> */}
        <div className="fileUpload">
          <Button onClick={this.onClick} text="Choose File" btnStyle="info" tooltip={inputTooltip} />
          <input type="file" ref="fileInput" name={name} className="upload" onChange={this.onChange} />
          {this.renderProgressBar()}
          <span className="help-block has-error error-msg">{errorMessage}</span>
        </div>
      </div>
    );
  }
}

export default S3FileUploader;
